import React from "react";
import * as yup from "yup";
import { keyFromIdentity } from "../helpers";
import { QuestionProps } from "../question";
import TextInput from "./text";

export const validator = (
  { identity, required }: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  const key = keyFromIdentity(identity, parent, index);
  const emailValidator = yup.string().email();
  return {
    [key]: required ? emailValidator.required() : emailValidator.nullable(),
  };
};

const EmailInput = (props : any) => <TextInput {...props} type="email" />;

EmailInput.validator = validator;
export default EmailInput;
